// import React from "react";
// import aboutImg from "../../images/about.png";

// const RestaurantAbout = () => {
//   return (
//     <section className="mahal-about-section">
//       <div className="container">
//         <div className="row align-items-center">

//           {/* LEFT CONTENT */}
//           <div className="col-lg-5 mt-4 mt-lg-0">
//             <div className="mahal-about-image">
//               <img src={aboutImg } alt="Restaurants" />
//             </div>
//           </div>
          

//           {/* RIGHT IMAGE */}
//             <div className="col-lg-7">
//             <div className="mahal-about-content">

//               <h6 className="mahal-subtitle"> <span> FOR </span> RESTAURANTS</h6>

//               <h2 className="mahal-title">
//                 Source Fresh Ingredients <br />
//                 from <span>Trusted Suppliers</span>
//               </h2>

//               <p className="mahal-desc">
//                 MAHAL helps restaurants simplify food procurement by connecting
//                 them with verified suppliers for daily and bulk sourcing.
//               </p>

//               <p class="mahal-text">From independent kitchens to multi-branch restaurant chains, MAHAL empowers restaurants with verified suppliers, transparent pricing, and streamlined bulk ordering — all in one unified platform.</p>

//               <div className="mahal-highlights">
//                 <div>✔ Verified & Reliable Suppliers</div>
//                 <div>✔ Transparent Pricing</div>
//                 <div>✔ Daily & Bulk Ordering</div>
//                 <div>✔ On-Time Delivery</div>
//               </div>

//               <div className="mahal-btn-group mt-4">
//                 <a href="/Registration" className="mahal-btn-primary">
//                   Order for Your Restaurant
//                 </a>
//               </div>

//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default RestaurantAbout;



// import React from "react";
// import { useTranslation } from "react-i18next";
// import aboutImg from "../../images/about.png";

// const RestaurantAbout = () => {
//   const { t } = useTranslation();

//   return (
//     <section className="mahal-about-section">
//       <div className="container">
//         <div className="row align-items-center">

//           {/* LEFT IMAGE */}
//           <div className="col-lg-5 mt-4 mt-lg-0">
//             <div className="mahal-about-image">
//               <img src={aboutImg} alt="Restaurants" />
//             </div>
//           </div>

//           {/* RIGHT CONTENT */}
//           <div className="col-lg-7">
//             <div className="mahal-about-content">

//               <h6 className="mahal-subtitle">
//                 <span>{t("restaurantabout.for")}</span> {t("restaurantabout.restaurants")}
//               </h6>

//               <h2 className="mahal-title">
//                 {t("restaurantabout.title1")} <br />
//                 {t("restaurantabout.title2")}{" "}
//                 <span>{t("restaurantabout.highlight")}</span>
//               </h2>

//               <p className="mahal-desc">
//                 {t("restaurantabout.desc")}
//               </p>

//               <p className="mahal-text">
//                 {t("restaurantabout.text")}
//               </p>

//               <div className="mahal-highlights">
//                 <div>✔ {t("restaurantabout.li1")}</div>
//                 <div>✔ {t("restaurantabout.li2")}</div>
//                 <div>✔ {t("restaurantabout.li3")}</div>
//                 <div>✔ {t("restaurantabout.li4")}</div>
//               </div>

//               <div className="mahal-btn-group mt-4">
//                 <a href="/Registration" className="mahal-btn-primary">
//                   {t("restaurantabout.cta")}
//                 </a>
//               </div>

//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default RestaurantAbout;



import React from "react";
import { useTranslation } from "react-i18next";
import aboutImg from "../../images/about.png";
import { FiShoppingCart, FiChevronRight } from "react-icons/fi";
import {
  BadgeCheck,
  BadgeDollarSign,
  ShoppingCart,
  Truck
} from "lucide-react";

const RestaurantAbout = () => {
  const { t } = useTranslation();

  return (
    <section className="mahal-about-section">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE */}
          <div className="col-lg-5 mt-4 mt-lg-0">
            <div className="mahal-about-image">
              <img src={aboutImg} alt="Restaurants" />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-7">
            <div className="mahal-about-content">

              {/* ================= Badge ================= */}
              <div className="mahal-subtitle-wrapper">

                {/* Icon */}
                <div className="subtitle-icon">
                  <svg
                    viewBox="0 0 64 64"
                    className="chef-icon"
                    fill="currentColor"
                  >
                    <path d="M32 8c-7 0-12 5-12 11v2c-4 1-7 5-7 10 0 6 5 11 11 11h16c6 0 11-5 11-11 0-5-3-9-7-10v-2c0-6-5-11-12-11zm-8 35h16v7H24z" />
                  </svg>
                </div>

                {/* Text */}
                <div className="subtitle-text-pill">
                  {t("restaurantabout.for")} {t("restaurantabout.restaurants")}
                </div>

                {/* Decorative Rays */}
                <div className="subtitle-spark">
                  <svg
                    width="30"
                    height="34"
                    viewBox="0 0 30 34"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="7"
                      y1="6"
                      x2="16"
                      y2="0"
                      stroke="#F57C00"
                      strokeWidth="3.5"
                      strokeLinecap="round"
                    />

                    <line
                      x1="11"
                      y1="17"
                      x2="28"
                      y2="17"
                      stroke="#F57C00"
                      strokeWidth="3.5"
                      strokeLinecap="round"
                    />

                    <line
                      x1="7"
                      y1="28"
                      x2="16"
                      y2="34"
                      stroke="#F57C00"
                      strokeWidth="3.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>

              </div>
              {/* =============== End Badge =============== */}
              <h2 className="mahal-title23">

                <span className="title1-text">
                  {t("restaurantabout.title1")}
                </span>

                <span className="title2-text">
                  {t("restaurantabout.title2")}
                </span>

                <div className="title-bottom">
                  <span className="from-text">
                    {t("restaurantabout.from")}
                  </span>

                  <span className="trusted-text">
                    {t("restaurantabout.highlight")}
                  </span>
                </div>

              </h2>
              <p className="mahal-desc">
                {t("restaurantabout.desc")}
              </p>

              <p className="mahal-text">
                {t("restaurantabout.text")}
              </p>

              <div className="mahal-feature-grid">

                <div className="feature-card">
                  <div className="feature-icon">
                    <BadgeCheck />
                  </div>
                  <h6>{t("restaurantabout.li1")}</h6>
                </div>

                <div className="feature-card">
                  <div className="feature-icon">
                    <BadgeDollarSign />
                  </div>
                  <h6>{t("restaurantabout.li2")}</h6>
                </div>

                <div className="feature-card">
                  <div className="feature-icon">
                    <ShoppingCart />
                  </div>
                  <h6>{t("restaurantabout.li3")}</h6>
                </div>

                <div className="feature-card">
                  <div className="feature-icon">
                    <Truck />
                  </div>
                  <h6>{t("restaurantabout.li4")}</h6>
                </div>

              </div>
              <div className="mahal-btn-group mt-4">
                <a href="/Registration" className="mahal-btn-primary restaurant-btn">

                  <FiShoppingCart className="btn-cart-icon1" />

                  <div className="btn-divider1"></div>

                  <p className="btn-text1">
                    {t("restaurantabout.cta")}
                  </p>

                  <FiChevronRight className="btn-arrow-icon1" />

                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default RestaurantAbout;